import React from 'react';
import Typography from '@material-ui/core/Typography';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'© 2019-'}
      {new Date().getFullYear()}
      {' Gigi Inc.'}
    </Typography>
  );
}

export default Copyright;
